import { LocalStorageService } from './local-storage-service';
import { CookieService } from './cookies';
import { apiEndpoints } from '../constants/api';
import axios from 'axios';
import { SessionStorageService } from './session-storage-service';
import { signInWithCustomToken } from 'firebase/auth';
import { auth } from '../config/firebase';
import * as Sentry from '@sentry/react';

const AUTH_TOKEN_KEY = 'accessToken';
export const CUSTOM_LOGIN_EMAIL = 'customEmail';

let isCustomLoginLoading = false;

export class AuthService {
  static getToken(): string | null {
    const token = LocalStorageService.getState<string>(AUTH_TOKEN_KEY);

    return token;
  }

  static getRockyToken(): string | null {
    const token = SessionStorageService.getState<string>(AUTH_TOKEN_KEY);

    return token;
  }

  static setRockyToken(token: string) {
    SessionStorageService.setState<string>(AUTH_TOKEN_KEY, token);
  }

  static clearRockyToken() {
    SessionStorageService.clearState(AUTH_TOKEN_KEY);
  }

  static clearToken() {
    LocalStorageService.clearState(AUTH_TOKEN_KEY);
  }

  static async customLogin(customEmail: string): Promise<boolean> {
    if (!customEmail) {
      return false;
    }

    LocalStorageService.clearState();
    if (!isCustomLoginLoading) {
      isCustomLoginLoading = true; // Move this up so it actually prevents double-firing!

      try {
        const response = await axios.get(
          apiEndpoints.authCustomLogin(customEmail),
        );
        const token = response.data;
        await signInWithCustomToken(auth, token);
        return true;
      } catch (error) {
        Sentry.captureException(error, { tags: { flow: 'custom-auth-login' } });
        CookieService.deleteCookie(CUSTOM_LOGIN_EMAIL);
        return false;
      } finally {
        isCustomLoginLoading = false;
      }
    }
    return false;
  }

  static setToken(token?: string) {
    LocalStorageService.setState(AUTH_TOKEN_KEY, token ?? '');
  }
}
